import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@src/design-system/tabs';
import { useLocation } from 'react-router-dom';
import { NotificationSection } from '../components/notification-section';
import { NotificationItem } from '../components/notification-item';
import { Text } from '@src/design-system/text';
import notificationApi from '../services/notification-api';
import { useDateSplitter } from '../hooks/use-date-spliter';
import { NotificationsFilter } from '../components/notifications-filter';
import qs from 'qs';
import { useNotificationsInfinityScroll } from '../hooks/use-infinity-scroll';
import { NotificationReadAll } from '../components/notification-read-all';

export const NotificationList = () => {
  const { search } = useLocation();

  const queryParam = qs.parse(search, { ignoreQueryPrefix: true });

  const { data: { count } = { count: 0 }, isLoading: isCountLoading } =
    notificationApi.useUnreadCount();

  const { notifications, isNotificationsEmpty, containerRef } =
    useNotificationsInfinityScroll({ queryParam });

  const { Today, Yesterday, Last7Days, Older } = useDateSplitter(
    notifications || []
  );

  const sections = [
    { title: 'Today', notifications: Today },
    { title: 'Yesterday', notifications: Yesterday },
    { title: 'Last 7 Days', notifications: Last7Days },
    { title: 'More than a week', notifications: Older },
  ].map((section, index, arr) => ({
    ...section,
    showMarkAll: index === arr.findIndex((s) => s.notifications.length > 0),
  }));

  return (
    <div>
      <div className='p-4 pb-2 flex items-center justify-between mb-4'>
        <Text variant='h3'>Notifications</Text>
      </div>

      <Tabs
        defaultValue='notifications'
        className='px-4'
      >
        <TabsList className='grid grid-cols-2 w-full border-b flex bg-white py-8'>
          <TabsTrigger
            value='notifications'
            className='relative font-semibold border-b-2 border-transparent data-[state=active]:border-[#5B31AA]'
          >
            Notifications {!isCountLoading && `(${count})`}
          </TabsTrigger>
          <TabsTrigger
            value='requests'
            className='relative font-semibold border-b-2 border-transparent data-[state=active]:border-[#5B31AA]'
          >
            Requests
          </TabsTrigger>
          <NotificationsFilter />
        </TabsList>

        <TabsContent value='notifications'>
          {isNotificationsEmpty ? (
            <div className='p-6 text-center text-gray-500 text-sm'>
              No notifications found.
            </div>
          ) : (
            <div
              className='max-h-[65vh] overflow-y-auto scrollbar-gray mb-2'
              ref={containerRef}
            >
              <div className='space-y-6 p-4'>
                {sections.map(
                  ({ title, notifications, showMarkAll }) =>
                    notifications.length > 0 && (
                      <NotificationSection
                        key={title}
                        title={title}
                        className='relative'
                      >
                        {showMarkAll && (
                          <NotificationReadAll
                            className={'absolute right-0 top-0'}
                          />
                        )}
                        {notifications.map((item) => (
                          <NotificationItem
                            key={item.id}
                            data={item}
                          />
                        ))}
                      </NotificationSection>
                    )
                )}
              </div>
            </div>
          )}
        </TabsContent>

        <TabsContent value='requests'>
          <div className='p-6 text-center text-gray-500 text-sm'>
            No new requests.
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};
